module.exports = __webpack_public_path__ + "static/media/Red_Arrow.27ab9caa.svg";